import * as z from "zod/v4";
import { IntegrationV2Schema } from "./integration-v2.js";
const IntegrationV2ResponseSchema_ = z.object({
    integration: IntegrationV2Schema,
});
export const IntegrationV2ResponseSchema = IntegrationV2ResponseSchema_;
//# sourceMappingURL=integration-v2-response.js.map